module.exports = __webpack_public_path__ + "static/media/maintain_social_distancing.78b69b07.png";